import { CopyToClipboard } from 'react-copy-to-clipboard';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import './CopyButton.css';

const BUTTON_TEXT_TIMEOUT_MS = 2000;

class CopyButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      buttonText: props.buttonText,
      buttonClass: 'btn-primary'
    };

    this.buttonTextTimeout = null;
    this.onCopy = this.onCopy.bind(this);
  }

  componentWillUnmount() {
    // clean up in case we unmount in the middle of a text-change timeout
    if (this.buttonTextTimeout) {
      clearTimeout(this.buttonTextTimeout);
      this.buttonTextTimeout = null;
    }
  }

  onCopy() {
    this.setState({ buttonText: 'Copied', buttonClass: 'btn-active' });
    this.buttonTextTimeout = setTimeout(() => {
      this.setState({
        buttonText: this.props.buttonText,
        buttonClass: 'btn-primary'
      });
    }, BUTTON_TEXT_TIMEOUT_MS);
  }

  render() {
    return (
      <CopyToClipboard text={this.props.copyContent} onCopy={this.onCopy}>
        <button
          onClick={this.props.onClick}
          aria-label="Copy to Clipboard"
          className={`btn copy-button ${this.state.buttonClass}`}
          type="button"
          data-testid="copy-to-clipboard-button"
        >
          {this.state.buttonText}
        </button>
      </CopyToClipboard>
    );
  }
}

CopyButton.propTypes = {
  buttonText: PropTypes.string,
  copyContent: PropTypes.string.isRequired,
  onClick: PropTypes.func
};

CopyButton.defaultProps = {
  onClick: () => {},
  buttonText: 'Copy'
};

export default CopyButton;
